import React from "react";

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-ivory-soft border-t border-forest-800/10 pt-20 pb-10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-16">
          <div className="md:col-span-7">
            <img
              src="https://customer-assets.emergentagent.com/job_ad-network-hub-3/artifacts/likzaj1c_Picture1.png"
              alt="Green Signs"
              className="h-28 w-auto object-contain"
              data-testid="footer-logo"
            />
            <p className="mt-6 text-forest-600 text-base font-light leading-relaxed max-w-md">
              India's premium <span className="text-brass font-medium tracking-wide">PrDOOH</span> network — designed for brands with the
              taste, and the patience, to be remembered.
            </p>
          </div>
          <div className="md:col-span-5">
            <div className="text-[10px] tracking-[0.3em] uppercase text-brass mb-5">
              Connect
            </div>
            <ul className="space-y-3 text-forest-600 text-sm">
              <li>varun@civitechdigital.com</li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-forest-800/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="text-xs text-forest-500">
            © {year} Green Signs Media. All rights reserved.
          </div>
          <div className="text-xs text-forest-500 tracking-[0.2em] uppercase">
            Made for the considered audience.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
